<template>
  <div class="scheduler-wrapper">
    <div class="timetable-container" v-if="currentDaySlots.length">
      <div :class="{
          'time-period-slot': true,
          selected: isSelected(slot),
          disabled: getDisabled(slot)
        }"
        v-for="slot in currentDaySlots"
        :key="slot._id"
        @click="toggleSlot(slot)">
          <p class="field-header" v-if="getField(slot)">
            {{ getField(slot) }}
          </p>
          <p class="c-gray f-light">
            {{ moment(slot.effectiveDate.from).format('hh:mm A') }} - {{ moment(slot.effectiveDate.to).format('hh:mm A') }}
          </p>
      </div>
      <!-- <div class="time-period" v-for="period in ['morning', 'afternoon', 'evening', 'night']" :key="period">
        <div class="time-period-header">
          <p>{{ period | toUpperCase }}</p>
        </div>
        <div class="time-period-body">

        </div>
      </div> -->
    </div>
    <div class="empty-placeholder" v-if="!currentDaySlots.length">
      <!-- <img src="@/assets/images/no-venue-slot.svg" alt=""> -->
      <h3 class="mt-15 c-text">No Booking Slots</h3>
      <span class="c-gray">The current date has no booking slots offered</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { get, cloneDeep } from 'lodash';

const inDateRange = (from, to) => {
  const now = moment();
  return now.isBetween(from, to);
};

export default {
  name: 'VenuSchedule',
  props: {
    currentDate: {
      type: Number,
      required: true,
    },
    slotArr: {
      type: Array,
      required: true,
    },
    venueId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      moment,
      currentCart: [],
      slots: [],
    };
  },
  mounted() {
    this.slots = cloneDeep(this.slotArr);
  },
  filters: {
    toUpperCase(value) {
      return value.toUpperCase();
    },
  },
  methods: {
    getDisabled(slot) {
      return slot.booking.length >= slot.maximum || !inDateRange(slot.bookingDateRange.from, slot.bookingDateRange.to);
    },
    getField(slot) {
      const fieldName = get(slot, 'meta.field.name');
      return fieldName;
    },
    toggleSlot(slot) {
      if (this.getDisabled(slot)) {
        return;
      }
      this.updateCartSlot({
        product: slot,
        quantity: 1,
      });
    },
    updateCartSlot(slot) {
      const index = this.currentCart.findIndex((item) => item.product._id === slot.product._id);
      if (index !== -1) {
        this.currentCart = this.currentCart.filter((item) => item.product._id !== slot.product._id);
      } else {
        this.currentCart.push(slot);
      }
      this.$emit('update-cart', this.currentCart);
    },
    isSelected(slot) {
      // eslint-disable-next-line no-underscore-dangle
      return this.currentCart.findIndex((s) => (s.product && s.product._id === slot._id)) !== -1;
    },
  },
  computed: {
    currentDaySlots() {
      return this.slots.filter((slot) => (
        slot.effectiveDate.from > moment(this.currentDate).startOf('day').valueOf()
         && slot.effectiveDate.to < moment(this.currentDate).endOf('day').valueOf()
      ));
    },
  },
  watch: {
    async currentDate(newDate) {
      try {
        const res = await this.$http.post(`/assemble/api/v1/admin/booking-slots/venues/${this.venueId}`, {
          effectiveDate: {
            from: moment(this.currentDate).startOf('day').valueOf(),
            to: moment(this.currentDate).add(1, 'day').startOf('day').valueOf(),
          },
        });
        const slots = res.data.data.bookingSlots;
        this.slots = slots;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .scheduler-wrapper {
    display: grid;
    gap: 0.5rem;
    width: 100%;
    min-height: 10rem;
  }

  .empty-placeholder {
      font-family: 'BrownStd-Regular';
      color: #8c8c8c;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      justify-content: center;
      img {
        max-width: 15rem;
      }
    }

  .timetable-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
    grid-gap: 0.5rem;
    .time-period-slot {
      .field-header {
        color: #8c8c8c;
        font-weight: 500;
      }

      &.disabled {
        opacity: 0.5;
        background: #f5f5f5;
        cursor: not-allowed !important;
      }

      &:hover {
        cursor: pointer;
      }

      &.selected {
        background-color: $highlight;
        p {
          color: #fff;
        }
      }

      font-family: 'BrownStd-Light';
      padding: 0.5rem;
      // display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background-color: #fff;
      // box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
      border: 1px solid #e9e5e5;
      // border: 1px solid #ccc;
      span {
        text-align: center;
        word-break: break-word;
        color: #8c8c8c;
      }
    }

    .time-period {
      display: flex;
      flex-direction: column;
      .time-period-header {
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          font-family: 'BrownStd-Regular';
        }
      }
      .time-period-body {
        margin-top: 1rem;
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>
